import Config from '@config';
import { initializeBiDashboardsApi } from '@gasbi/shared/common/features';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  biDashboardsApi,
  useGetBiDashboardsQuery,
  useLazyGetBiDashboardEmbedTokenQuery,
} = initializeBiDashboardsApi({
  baseUrl: `${Config.VITE_API_URL}/bi-dashboards`,
  baseQuery: axiosBaseQuery,
});
